var render = function render(){var _vm=this,_c=_vm._self._c;return _c('listado-noticias',{attrs:{"endpoint":"/noticias/todasNoticiasVisibles","title":"Noticias","eyebrow":"Actualidad","subtitle":"Toda la actualidad de la parroquia."}})
}
var staticRenderFns = []

export { render, staticRenderFns }